/**
 * AppShell — the canonical application frame: collapsible LeftNav, TopBar, and
 * a scrolling content region for the routed page. Wraps content in a
 * ShellProvider so pages can feed the top bar their breadcrumb/stage slots.
 */
import type { CSSProperties, ReactNode } from 'react';
import { colors } from '../theme';
import { LeftNav } from './LeftNav';
import { TopBar } from './TopBar';
import { ShellProvider } from './shellContext';

export interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  return (
    <ShellProvider>
      <div style={frame}>
        <LeftNav />
        <div style={main}>
          <TopBar />
          <main style={content}>{children}</main>
        </div>
      </div>
    </ShellProvider>
  );
}

const frame: CSSProperties = {
  display: 'flex',
  minHeight: '100vh',
  background: colors.pageBg,
};
const main: CSSProperties = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
};
const content: CSSProperties = {
  flex: 1,
  padding: 24,
  maxWidth: 1320,
  width: '100%',
  margin: '0 auto',
};
